export type HandoffConversationState = { status: string; operatorOverrideActive?: boolean | null };

const TRANSFERABLE_STATUSES = new Set([
    'draft_ready',
    'human_review_required',
    'waiting_for_reply',
    'active',
    'payment_pending',
]);

export function isHumanControlled(conversation: HandoffConversationState) {
    return conversation.status === 'human_handoff' && conversation.operatorOverrideActive === true;
}

export function canHandoff(conversation: HandoffConversationState) {
    return TRANSFERABLE_STATUSES.has(conversation.status) && conversation.operatorOverrideActive === false;
}

export class ConversationHandoffError extends Error {
    constructor(public kind: 'preflight' | 'unavailable' | 'changed' | 'rejected' | 'uncertain') {
        super(kind);
        this.name = 'ConversationHandoffError';
    }
}
